/**
 * HedgeMark — pale-cyan highlight wrapping probabilistic claims in prose.
 *
 * Makes the hedge posture visible without copy needing to do all the work.
 * Per Phase 1 RE-LOCK §2.6 (white-majority discipline) and the locked Q4
 * decision (2026-05-02): the AI emits a `hedge_phrases` array in its Layer 4
 * output naming the exact phrases it used; the markdown renderer wraps each
 * occurrence in this component.
 *
 * Prints lightly — the pale cyan tint is part of the print-friendly palette
 * choice.
 */

export default function HedgeMark({ children }) {
  return (
    <span
      style={{
        background: "var(--ppr-color-accent-pale)",
        padding: "1px 4px",
        borderRadius: "var(--ppr-radius-sm)",
      }}
      data-component="HedgeMark"
    >
      {children}
    </span>
  );
}
